import React from "react"
import Lang from "@components/Lang/Lang"
import {Modal, Form, Input, DatePicker, Select, } from "antd"
import dayjs from 'dayjs'
import './ExportData.less'
import {getSomeTimeMilliseconds} from '@/utils/timeHandler'

const { RangePicker } = DatePicker;
const { Option } = Select;
const config = require("../../../../../config/config");
const Locale = require("../../../../utils/locale").default;
let locale = Locale.current();
const ExportData = (props) => {
    // console.log('props.isModalVisible', props.isModalVisible);

    const [form] = Form.useForm()

    const handleOk = () => {
        const formData = form.getFieldsValue() || {}

        // console.log(dayjs(formData.time[0]._d).valueOf());
        let template =
            locale === "ru" ? "MgSaleDataReport_ru" : "MgSaleDataReport_zh";
        let href = config.servers[config.environment].exportApi +
            `/data/bpms/jreport/mg/saleData/print?template=${template}&%24isGetHttpConfig=true&isCheck=0&lang=${locale}`;

        //地址拼接，如果没有数据也要拼接
        href += `&createTimeStart=${(formData.time&&getSomeTimeMilliseconds(formData.time[0], '00:00:00')) || ""}`;
        href += `&createTimeEnd=${(formData.time&&getSomeTimeMilliseconds(formData.time[1], '23:59:59')) || ""}`;

        if(formData.time2&&formData.time2[0]){
            href += `&payDepositTimeStart=${(getSomeTimeMilliseconds(formData.time2[0], '00:00:00')) || ""}`;
        }
        if(formData.time2&&formData.time2[1]){
            href += `&payDepositTimeEnd=${(getSomeTimeMilliseconds(formData.time2[1], '23:59:59')) || ""}`;
        }

        if(formData.time3&&formData.time3[0]){
            href += `&payFinalPaymentTimeStart=${(getSomeTimeMilliseconds(formData.time3[0], '00:00:00')) || ""}`;
        }
        if(formData.time3&&formData.time3[1]){
            href += `&payFinalPaymentTimeEnd=${(getSomeTimeMilliseconds(formData.time3[1], '23:59:59')) || ""}`;
        }

       href += `&status=${(formData.status&&formData.status.trim()) || ''}`
       href += `&buyerCode=${(formData.buyerCode&&formData.buyerCode.trim()) || ''}`

        window.open(href);

        handleCancel()
    };

    const handleCancel = () => {
        props.showSwich(false)
    };

    return (
        <Modal title={Lang({id: 'DaoChuShuJuShaiXuan', default: '导出数据筛选'})}
               className="sale-statistics-exportModal"
               open={props.isModalVisible}
               onOk={handleOk}
               onCancel={handleCancel}
               cancelText={Lang({id: 'QuXiao', default: '取消'})}
               cancelButtonProps={{shape:'round'}}
               okButtonProps={{type:'primary', shape:'round'}}
               okText={Lang({id: 'DaoChu', default: '导出'})}>
            <Form labelCol={{span: 5}}
                  form={form}
                  labelAlign="left">
                <Form.Item
                    name="time"
                    label={(
                    <span className="label-txt">{Lang({id: 'XiaDanShiJian', default: '下单时间'})}</span>
                )}>
                    <RangePicker
                        style={{width: '312px'}}
                        // showTime={true}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="time2"
                    label={(
                        <span className="label-txt">{Lang({id: 'ZhiFuDingJin', default: '支付定金'})}</span>
                    )}>
                    <RangePicker
                        style={{width: '312px'}}
                        // showTime={true}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="time3"
                    label={(
                        <span className="label-txt">{Lang({id: 'ZhiFuWeiKuan', default: '支付尾款'})}</span>
                    )}>
                    <RangePicker
                        style={{width: '312px'}}
                        // showTime={true}
                        placeholder={[Lang({id:'KaiShiShiJian', default:'开始时间'}), Lang({id:'JieShuShiJian', default:'结束时间'})]}/>
                </Form.Item>

                <Form.Item
                    name="buyerCode"
                    label={Lang({id:'KeHu', default:'客户'})}>
                    <Input
                        style={{width: '312px'}}
                        placeholder={Lang({id:'QingShuRuCaiGouShangBianMa', default:'请输入采购商编码'})}></Input>
                </Form.Item>

                <Form.Item
                    name="status"
                    label={Lang({id:'DingDanZhuangTai', default:'订单状态'})}>
                    <Select style={{ width: "312px" }}
                            placeholder={Lang({id:'QingXuanZeDingDanZhuangTai', default:'请选择订单状态'})}>
                        <Option value="">{Lang({id: 'QuanBu', default: '全部'})}</Option>
                        {__getDictList('sale_po_ddp_status_buyer').map(item => (
                            <Option key={item.id} value={item.code}>{item.name}</Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ExportData
